import PageHeader from '../components/PageHeader';
import Footer from '../components/Footer';
import './Pages.css';

function Services() {
  return (
    <div className="Page">
      <PageHeader />
      <div className="Page-container">
        <h1>Services</h1>

        <section className="Page-section">
          <h2>Security Consulting</h2>
          <p>
            Strategic security guidance tailored to your business needs. We help you build robust
            security programs that protect your assets and ensure compliance.
          </p>
          <ul>
            <li>Security architecture review</li>
            <li>Risk assessment and management</li>
            <li>Security policy development</li>
            <li>Compliance consulting (SOC 2, ISO 27001, HIPAA, PCI-DSS)</li>
          </ul>
        </section>

        <section className="Page-section">
          <h2>Identity And Access Management</h2>
          <p>
            Comprehensive IAM solutions to ensure the right people have access to the right resources
            at the right time. Protect your systems while enabling seamless user experiences.
          </p>
          <ul>
            <li>IAM strategy and roadmap development</li>
            <li>Identity governance and administration</li>
            <li>Multi-factor authentication (MFA) implementation</li>
            <li>Privileged access management (PAM)</li>
            <li>Single sign-on (SSO) solutions</li>
          </ul>
        </section>

        <section className="Page-section">
          <h2>Vulnerability Management</h2>
          <p>
            Proactive identification and remediation of security vulnerabilities across your infrastructure.
            Stay ahead of threats with continuous monitoring and assessment.
          </p>
          <ul>
            <li>Vulnerability scanning and assessment</li>
            <li>Patch management strategy</li>
            <li>Security configuration reviews</li>
            <li>Penetration testing</li>
            <li>Continuous vulnerability monitoring</li>
          </ul>
        </section>

        <section className="Page-section">
          <h2>Incident Management</h2>
          <p>
            24/7 incident response capabilities to quickly detect, contain, and remediate security
            incidents. Minimize damage and restore normal operations efficiently.
          </p>
          <ul>
            <li>Incident response planning and readiness</li>
            <li>Security incident detection and analysis</li>
            <li>Breach containment and remediation</li>
            <li>Forensic investigation</li>
            <li>Post-incident analysis and reporting</li>
          </ul>
        </section>

        <section className="Page-section">
          <h2>Security Training</h2>
          <p>
            Empower your team with the knowledge to recognize and prevent security threats.
            Custom training programs designed for your organization's needs.
          </p>
          <ul>
            <li>Security awareness training</li>
            <li>Phishing simulation campaigns</li>
            <li>Developer security training (secure coding)</li>
            <li>Executive security briefings</li>
            <li>Compliance and regulatory training</li>
          </ul>
        </section>
      </div>
      <Footer />
    </div>
  );
}

export default Services;
